/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.213.0-v202610211814-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqCustomAgentsApiClass {
 
   constructor() {}

  /**
   * @summary Archive a custom agent. This endpoint is experimental and may change in future releases.
   * @param {string} id - The custom agent ID
  */
  public archiveCustomAgent(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Create a new custom agent. This endpoint is experimental and may change in future releases.
  */
  public createCustomAgent(
    body: models.CustomAgentInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents`;
    const urlTemplate = `${baseUrl}/custom-agents`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.CustomAgentOutputV1>;
  }

  /**
   * @summary Create the current user's custom agent draft working copy. This endpoint is experimental and may change in future releases.
   * @param {string} id - The custom agent ID
  */
  public createCustomAgentDraft(
    body: models.CustomAgentDraftCreateInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}/draft`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}/draft`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.CustomAgentOutputV1>;
  }

  /**
   * @summary Create a new version from the caller's draft. This endpoint is experimental and may change in future releases.
   * @param {string} id - The custom agent ID
  */
  public createCustomAgentVersion(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}/versions`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}/versions`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<Array<models.CustomAgentVersionOutputV1>>;
  }

  /**
   * @summary Delete the saved trigger for a custom agent. This endpoint is experimental and may change in future releases.
   * @param {string} id
  */
  public deleteCustomAgentTrigger(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}/trigger`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}/trigger`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Discard the caller's draft working copy for a versioned custom agent. This endpoint is experimental and may change in future releases.
   * @param {string} id - The custom agent ID
  */
  public discardCustomAgentDraft(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}/draft`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}/draft`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Duplicate a custom agent from its production version. This endpoint is experimental and may change in future releases.
   * @param {string} id - The custom agent ID
  */
  public duplicateCustomAgent(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}/duplicate`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}/duplicate`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.CustomAgentOutputV1>;
  }

  /**
   * @summary Get a custom agent. This endpoint is experimental and may change in future releases.
   * @param {string} id - The custom agent ID
  */
  public getCustomAgent(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.CustomAgentOutputV1>;
  }

  /**
   * @summary Get a list of active drafts for a custom agent. This endpoint is experimental and may change in future releases.
   * @param {string} id - The custom agent ID
  */
  public getCustomAgentDraftWorkingCopies(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}/drafts`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}/drafts`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<Array<models.CustomAgentDraftOutputV1>>;
  }

  /**
   * @summary Get the saved trigger for a custom agent. This endpoint is experimental and may change in future releases.
   * @param {string} id
  */
  public getCustomAgentTrigger(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}/trigger`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}/trigger`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.CustomAgentTriggerOutputV1>;
  }

  /**
   * @summary Get a workflow graph for a specific version. This endpoint is experimental and may change in future releases.
   * @param {string} id - The custom agent ID
   * @param {string} versionId - The version ID
  */
  public getCustomAgentVersionGraph(
    {
      id,
      versionId
    } : {
      id: string,
      versionId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (versionId === null || versionId === undefined) {
      throw new Error("'versionId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}/versions/${encodeURIComponent(String(versionId))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{versionId}', encodeURIComponent(String(versionId)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}/versions/{versionId}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.CustomAgentOutputV1>;
  }

  /**
   * @summary Get versions for a custom agent. This endpoint is experimental and may change in future releases.
   * @param {string} id - The custom agent ID
  */
  public getCustomAgentVersions(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}/versions`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}/versions`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<Array<models.CustomAgentVersionOutputV1>>;
  }

  /**
   * @summary Get a list of custom agents. This endpoint is experimental and may change in future releases.
   * @param {boolean} [versioned] - Filter by versioned state
   * @param {string} [production=any] - Production filter: any, set, or unset
   * @param {string} [ownership=all] - Ownership filter: all, mine, or accessible (owned by or shared with the caller)
   * @param {number} [offset=0] - The pagination offset, the number of matching items to skip
   * @param {number} [limit=40] - The pagination limit, the maximum number of items to return
   * @param {boolean} [includeProductionMetadata=false] - Include production version and Start node trigger metadata
  */
  public getCustomAgents(
    {
      versioned,
      production,
      ownership,
      offset,
      limit,
      includeProductionMetadata
    } : {
      versioned?: boolean,
      production?: GetCustomAgentsProductionEnum,
      ownership?: GetCustomAgentsOwnershipEnum,
      offset?: number,
      limit?: number,
      includeProductionMetadata?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents`;
    const urlTemplate = `${baseUrl}/custom-agents`;

    const queryParams = {
      ['versioned']: versioned,      ['production']: production,      ['ownership']: ownership,      ['offset']: offset,      ['limit']: limit,      ['includeProductionMetadata']: includeProductionMetadata
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<Array<models.CustomAgentSummaryOutputV1>>;
  }

  /**
   * @summary Create or replace the saved trigger for a custom agent. This endpoint is experimental and may change in future releases.
   * @param {string} id
  */
  public putCustomAgentTrigger(
    body: models.CustomAgentTriggerInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}/trigger`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}/trigger`;



    return axiosInstance.request({
      method: 'put',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.CustomAgentTriggerOutputV1>;
  }

  /**
   * @summary Revert the caller's draft working copy to a specific version. This endpoint is experimental and may change in future releases.
   * @param {string} id - The custom agent ID
   * @param {string} versionId - The version ID
  */
  public revertCustomAgentToVersion(
    {
      id,
      versionId
    } : {
      id: string,
      versionId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (versionId === null || versionId === undefined) {
      throw new Error("'versionId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}/revert/${encodeURIComponent(String(versionId))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{versionId}', encodeURIComponent(String(versionId)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}/revert/{versionId}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.CustomAgentOutputV1>;
  }

  /**
   * @summary Set or unset the production version for the custom agent. This endpoint is experimental and may change in future releases.
   * @param {string} id - The custom agent ID
  */
  public setCustomAgentProduction(
    body: models.CustomAgentProductionInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}/production`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}/production`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<Array<models.CustomAgentVersionOutputV1>>;
  }

  /**
   * @summary Update custom agent metadata without modifying draft workflow state. This endpoint is experimental and may change in future releases.
   * @param {string} id - The custom agent ID
  */
  public updateCustomAgent(
    body: models.CustomAgentMetadataUpdateInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}`;



    return axiosInstance.request({
      method: 'put',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.CustomAgentOutputV1>;
  }

  /**
   * @summary Update the current user's custom agent draft working copy. This endpoint is experimental and may change in future releases.
   * @param {string} id - The custom agent ID
  */
  public updateCustomAgentDraft(
    body: models.CustomAgentDraftUpdateInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/custom-agents/${encodeURIComponent(String(id))}/draft`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/custom-agents/{id}/draft`;



    return axiosInstance.request({
      method: 'put',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.CustomAgentOutputV1>;
  }

}

export const GetCustomAgentsProductionEnum = {
    Any: 'any',
    Set: 'set',
    Unset: 'unset'
} as const;

export type GetCustomAgentsProductionEnum = typeof GetCustomAgentsProductionEnum[keyof typeof GetCustomAgentsProductionEnum];
export const GetCustomAgentsOwnershipEnum = {
    All: 'all',
    Mine: 'mine',
    Accessible: 'accessible'
} as const;

export type GetCustomAgentsOwnershipEnum = typeof GetCustomAgentsOwnershipEnum[keyof typeof GetCustomAgentsOwnershipEnum];

export const sqCustomAgentsApi = new sqCustomAgentsApiClass();

export type sqCustomAgentsApiEndpoints = {
  'archiveCustomAgent': {
    method: 'delete';
    path: '/custom-agents/${encodeURIComponent(String(id))}';
    response: models.ArchiveOutputV1;
  };
  'createCustomAgent': {
    method: 'post';
    path: '/custom-agents';
    response: models.CustomAgentOutputV1;
  };
  'createCustomAgentDraft': {
    method: 'post';
    path: '/custom-agents/${encodeURIComponent(String(id))}/draft';
    response: models.CustomAgentOutputV1;
  };
  'createCustomAgentVersion': {
    method: 'post';
    path: '/custom-agents/${encodeURIComponent(String(id))}/versions';
    response: Array<models.CustomAgentVersionOutputV1>;
  };
  'deleteCustomAgentTrigger': {
    method: 'delete';
    path: '/custom-agents/${encodeURIComponent(String(id))}/trigger';
    response: {};
  };
  'discardCustomAgentDraft': {
    method: 'delete';
    path: '/custom-agents/${encodeURIComponent(String(id))}/draft';
    response: {};
  };
  'duplicateCustomAgent': {
    method: 'post';
    path: '/custom-agents/${encodeURIComponent(String(id))}/duplicate';
    response: models.CustomAgentOutputV1;
  };
  'getCustomAgent': {
    method: 'get';
    path: '/custom-agents/${encodeURIComponent(String(id))}';
    response: models.CustomAgentOutputV1;
  };
  'getCustomAgentDraftWorkingCopies': {
    method: 'get';
    path: '/custom-agents/${encodeURIComponent(String(id))}/drafts';
    response: Array<models.CustomAgentDraftOutputV1>;
  };
  'getCustomAgentTrigger': {
    method: 'get';
    path: '/custom-agents/${encodeURIComponent(String(id))}/trigger';
    response: models.CustomAgentTriggerOutputV1;
  };
  'getCustomAgentVersionGraph': {
    method: 'get';
    path: '/custom-agents/${encodeURIComponent(String(id))}/versions/${encodeURIComponent(String(versionId))}';
    response: models.CustomAgentOutputV1;
  };
  'getCustomAgentVersions': {
    method: 'get';
    path: '/custom-agents/${encodeURIComponent(String(id))}/versions';
    response: Array<models.CustomAgentVersionOutputV1>;
  };
  'getCustomAgents': {
    method: 'get';
    path: '/custom-agents';
    response: Array<models.CustomAgentSummaryOutputV1>;
  };
  'putCustomAgentTrigger': {
    method: 'put';
    path: '/custom-agents/${encodeURIComponent(String(id))}/trigger';
    response: models.CustomAgentTriggerOutputV1;
  };
  'revertCustomAgentToVersion': {
    method: 'post';
    path: '/custom-agents/${encodeURIComponent(String(id))}/revert/${encodeURIComponent(String(versionId))}';
    response: models.CustomAgentOutputV1;
  };
  'setCustomAgentProduction': {
    method: 'post';
    path: '/custom-agents/${encodeURIComponent(String(id))}/production';
    response: Array<models.CustomAgentVersionOutputV1>;
  };
  'updateCustomAgent': {
    method: 'put';
    path: '/custom-agents/${encodeURIComponent(String(id))}';
    response: models.CustomAgentOutputV1;
  };
  'updateCustomAgentDraft': {
    method: 'put';
    path: '/custom-agents/${encodeURIComponent(String(id))}/draft';
    response: models.CustomAgentOutputV1;
  };
};

type ApiArchiveCustomAgentResponse = models.ArchiveOutputV1;
type ApiarchiveCustomAgentMutationParams = Parameters<typeof sqCustomAgentsApi.archiveCustomAgent> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCustomAgentsApi.archiveCustomAgent>;

export function useApiArchiveCustomAgentMutation(
  options?: Omit<UseMutationOptions<ApiArchiveCustomAgentResponse, AxiosError<SeeqErrorData>,
    ApiarchiveCustomAgentMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveCustomAgentResponse, AxiosError<SeeqErrorData>,
  ApiarchiveCustomAgentMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveCustomAgentMutationParams) =>
      sqCustomAgentsApi.archiveCustomAgent(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateCustomAgentResponse = models.CustomAgentOutputV1;
type ApicreateCustomAgentMutationParams = Parameters<typeof sqCustomAgentsApi.createCustomAgent> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCustomAgentsApi.createCustomAgent>;
type ApicreateCustomAgentMutationVariables = models.CustomAgentInputV1;

export function useApiCreateCustomAgentMutation(
  options?: Omit<UseMutationOptions<ApiCreateCustomAgentResponse, AxiosError<SeeqErrorData>,
    ApicreateCustomAgentMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateCustomAgentResponse, AxiosError<SeeqErrorData>,
  ApicreateCustomAgentMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateCustomAgentMutationVariables) =>
      sqCustomAgentsApi.createCustomAgent(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateCustomAgentDraftResponse = models.CustomAgentOutputV1;
type ApicreateCustomAgentDraftMutationParams = Parameters<typeof sqCustomAgentsApi.createCustomAgentDraft> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCustomAgentsApi.createCustomAgentDraft>;

export function useApiCreateCustomAgentDraftMutation(
  options?: Omit<UseMutationOptions<ApiCreateCustomAgentDraftResponse, AxiosError<SeeqErrorData>,
    ApicreateCustomAgentDraftMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateCustomAgentDraftResponse, AxiosError<SeeqErrorData>,
  ApicreateCustomAgentDraftMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApicreateCustomAgentDraftMutationParams) =>
      sqCustomAgentsApi.createCustomAgentDraft(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateCustomAgentVersionResponse = Array<models.CustomAgentVersionOutputV1>;
type ApicreateCustomAgentVersionMutationParams = Parameters<typeof sqCustomAgentsApi.createCustomAgentVersion> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCustomAgentsApi.createCustomAgentVersion>;

export function useApiCreateCustomAgentVersionMutation(
  options?: Omit<UseMutationOptions<ApiCreateCustomAgentVersionResponse, AxiosError<SeeqErrorData>,
    ApicreateCustomAgentVersionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateCustomAgentVersionResponse, AxiosError<SeeqErrorData>,
  ApicreateCustomAgentVersionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApicreateCustomAgentVersionMutationParams) =>
      sqCustomAgentsApi.createCustomAgentVersion(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteCustomAgentTriggerResponse = {};
type ApideleteCustomAgentTriggerMutationParams = Parameters<typeof sqCustomAgentsApi.deleteCustomAgentTrigger> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCustomAgentsApi.deleteCustomAgentTrigger>;

export function useApiDeleteCustomAgentTriggerMutation(
  options?: Omit<UseMutationOptions<ApiDeleteCustomAgentTriggerResponse, AxiosError<SeeqErrorData>,
    ApideleteCustomAgentTriggerMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteCustomAgentTriggerResponse, AxiosError<SeeqErrorData>,
  ApideleteCustomAgentTriggerMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteCustomAgentTriggerMutationParams) =>
      sqCustomAgentsApi.deleteCustomAgentTrigger(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDiscardCustomAgentDraftResponse = {};
type ApidiscardCustomAgentDraftMutationParams = Parameters<typeof sqCustomAgentsApi.discardCustomAgentDraft> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCustomAgentsApi.discardCustomAgentDraft>;

export function useApiDiscardCustomAgentDraftMutation(
  options?: Omit<UseMutationOptions<ApiDiscardCustomAgentDraftResponse, AxiosError<SeeqErrorData>,
    ApidiscardCustomAgentDraftMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDiscardCustomAgentDraftResponse, AxiosError<SeeqErrorData>,
  ApidiscardCustomAgentDraftMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApidiscardCustomAgentDraftMutationParams) =>
      sqCustomAgentsApi.discardCustomAgentDraft(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDuplicateCustomAgentResponse = models.CustomAgentOutputV1;
type ApiduplicateCustomAgentMutationParams = Parameters<typeof sqCustomAgentsApi.duplicateCustomAgent> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCustomAgentsApi.duplicateCustomAgent>;

export function useApiDuplicateCustomAgentMutation(
  options?: Omit<UseMutationOptions<ApiDuplicateCustomAgentResponse, AxiosError<SeeqErrorData>,
    ApiduplicateCustomAgentMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDuplicateCustomAgentResponse, AxiosError<SeeqErrorData>,
  ApiduplicateCustomAgentMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiduplicateCustomAgentMutationParams) =>
      sqCustomAgentsApi.duplicateCustomAgent(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetCustomAgentResponse = models.CustomAgentOutputV1;
export function GetCustomAgentQueryKey(
  params: Parameters<typeof sqCustomAgentsApi.getCustomAgent>[0],
) {
  return ['sqCustomAgentsApi', 'getCustomAgent', params] as const;
}

export function useApiGetCustomAgentQuery(
  params: Parameters<typeof sqCustomAgentsApi.getCustomAgent>[0],
  options?: Omit<UseQueryOptions<ApiGetCustomAgentResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetCustomAgentResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetCustomAgentQueryKey(params),
    queryFn: () =>
      sqCustomAgentsApi.getCustomAgent(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetCustomAgentDraftWorkingCopiesResponse = Array<models.CustomAgentDraftOutputV1>;
export function GetCustomAgentDraftWorkingCopiesQueryKey(
  params: Parameters<typeof sqCustomAgentsApi.getCustomAgentDraftWorkingCopies>[0],
) {
  return ['sqCustomAgentsApi', 'getCustomAgentDraftWorkingCopies', params] as const;
}

export function useApiGetCustomAgentDraftWorkingCopiesQuery(
  params: Parameters<typeof sqCustomAgentsApi.getCustomAgentDraftWorkingCopies>[0],
  options?: Omit<UseQueryOptions<ApiGetCustomAgentDraftWorkingCopiesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetCustomAgentDraftWorkingCopiesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetCustomAgentDraftWorkingCopiesQueryKey(params),
    queryFn: () =>
      sqCustomAgentsApi.getCustomAgentDraftWorkingCopies(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetCustomAgentTriggerResponse = models.CustomAgentTriggerOutputV1;
export function GetCustomAgentTriggerQueryKey(
  params: Parameters<typeof sqCustomAgentsApi.getCustomAgentTrigger>[0],
) {
  return ['sqCustomAgentsApi', 'getCustomAgentTrigger', params] as const;
}

export function useApiGetCustomAgentTriggerQuery(
  params: Parameters<typeof sqCustomAgentsApi.getCustomAgentTrigger>[0],
  options?: Omit<UseQueryOptions<ApiGetCustomAgentTriggerResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetCustomAgentTriggerResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetCustomAgentTriggerQueryKey(params),
    queryFn: () =>
      sqCustomAgentsApi.getCustomAgentTrigger(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetCustomAgentVersionGraphResponse = models.CustomAgentOutputV1;
export function GetCustomAgentVersionGraphQueryKey(
  params: Parameters<typeof sqCustomAgentsApi.getCustomAgentVersionGraph>[0],
) {
  return ['sqCustomAgentsApi', 'getCustomAgentVersionGraph', params] as const;
}

export function useApiGetCustomAgentVersionGraphQuery(
  params: Parameters<typeof sqCustomAgentsApi.getCustomAgentVersionGraph>[0],
  options?: Omit<UseQueryOptions<ApiGetCustomAgentVersionGraphResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetCustomAgentVersionGraphResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetCustomAgentVersionGraphQueryKey(params),
    queryFn: () =>
      sqCustomAgentsApi.getCustomAgentVersionGraph(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetCustomAgentVersionsResponse = Array<models.CustomAgentVersionOutputV1>;
export function GetCustomAgentVersionsQueryKey(
  params: Parameters<typeof sqCustomAgentsApi.getCustomAgentVersions>[0],
) {
  return ['sqCustomAgentsApi', 'getCustomAgentVersions', params] as const;
}

export function useApiGetCustomAgentVersionsQuery(
  params: Parameters<typeof sqCustomAgentsApi.getCustomAgentVersions>[0],
  options?: Omit<UseQueryOptions<ApiGetCustomAgentVersionsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetCustomAgentVersionsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetCustomAgentVersionsQueryKey(params),
    queryFn: () =>
      sqCustomAgentsApi.getCustomAgentVersions(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetCustomAgentsResponse = Array<models.CustomAgentSummaryOutputV1>;
export function GetCustomAgentsQueryKey(
  params: Parameters<typeof sqCustomAgentsApi.getCustomAgents>[0],
) {
  return ['sqCustomAgentsApi', 'getCustomAgents', params] as const;
}

export function useApiGetCustomAgentsQuery(
  params: Parameters<typeof sqCustomAgentsApi.getCustomAgents>[0],
  options?: Omit<UseQueryOptions<ApiGetCustomAgentsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetCustomAgentsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetCustomAgentsQueryKey(params),
    queryFn: () =>
      sqCustomAgentsApi.getCustomAgents(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiPutCustomAgentTriggerResponse = models.CustomAgentTriggerOutputV1;
type ApiputCustomAgentTriggerMutationParams = Parameters<typeof sqCustomAgentsApi.putCustomAgentTrigger> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCustomAgentsApi.putCustomAgentTrigger>;

export function useApiPutCustomAgentTriggerMutation(
  options?: Omit<UseMutationOptions<ApiPutCustomAgentTriggerResponse, AxiosError<SeeqErrorData>,
    ApiputCustomAgentTriggerMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPutCustomAgentTriggerResponse, AxiosError<SeeqErrorData>,
  ApiputCustomAgentTriggerMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiputCustomAgentTriggerMutationParams) =>
      sqCustomAgentsApi.putCustomAgentTrigger(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiRevertCustomAgentToVersionResponse = models.CustomAgentOutputV1;
type ApirevertCustomAgentToVersionMutationParams = Parameters<typeof sqCustomAgentsApi.revertCustomAgentToVersion> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCustomAgentsApi.revertCustomAgentToVersion>;

export function useApiRevertCustomAgentToVersionMutation(
  options?: Omit<UseMutationOptions<ApiRevertCustomAgentToVersionResponse, AxiosError<SeeqErrorData>,
    ApirevertCustomAgentToVersionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRevertCustomAgentToVersionResponse, AxiosError<SeeqErrorData>,
  ApirevertCustomAgentToVersionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApirevertCustomAgentToVersionMutationParams) =>
      sqCustomAgentsApi.revertCustomAgentToVersion(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSetCustomAgentProductionResponse = Array<models.CustomAgentVersionOutputV1>;
type ApisetCustomAgentProductionMutationParams = Parameters<typeof sqCustomAgentsApi.setCustomAgentProduction> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCustomAgentsApi.setCustomAgentProduction>;

export function useApiSetCustomAgentProductionMutation(
  options?: Omit<UseMutationOptions<ApiSetCustomAgentProductionResponse, AxiosError<SeeqErrorData>,
    ApisetCustomAgentProductionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiSetCustomAgentProductionResponse, AxiosError<SeeqErrorData>,
  ApisetCustomAgentProductionMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApisetCustomAgentProductionMutationParams) =>
      sqCustomAgentsApi.setCustomAgentProduction(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateCustomAgentResponse = models.CustomAgentOutputV1;
type ApiupdateCustomAgentMutationParams = Parameters<typeof sqCustomAgentsApi.updateCustomAgent> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCustomAgentsApi.updateCustomAgent>;

export function useApiUpdateCustomAgentMutation(
  options?: Omit<UseMutationOptions<ApiUpdateCustomAgentResponse, AxiosError<SeeqErrorData>,
    ApiupdateCustomAgentMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateCustomAgentResponse, AxiosError<SeeqErrorData>,
  ApiupdateCustomAgentMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateCustomAgentMutationParams) =>
      sqCustomAgentsApi.updateCustomAgent(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateCustomAgentDraftResponse = models.CustomAgentOutputV1;
type ApiupdateCustomAgentDraftMutationParams = Parameters<typeof sqCustomAgentsApi.updateCustomAgentDraft> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqCustomAgentsApi.updateCustomAgentDraft>;

export function useApiUpdateCustomAgentDraftMutation(
  options?: Omit<UseMutationOptions<ApiUpdateCustomAgentDraftResponse, AxiosError<SeeqErrorData>,
    ApiupdateCustomAgentDraftMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateCustomAgentDraftResponse, AxiosError<SeeqErrorData>,
  ApiupdateCustomAgentDraftMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateCustomAgentDraftMutationParams) =>
      sqCustomAgentsApi.updateCustomAgentDraft(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
